import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { STORAGE_KEYS } from "../constants";
import { removeFromStorage } from "../helpers";
import { USER } from "../types/User";
import { RootState } from "../app/store";

export interface AuthState {
  user: USER | null;
  token: any;
  tempToken: string | null;
  deviceToken: string | null;
  permissions?: string[] | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
  tempToken: null,
  permissions: null,
  deviceToken: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    resetAuth: (state) => {
      removeFromStorage(STORAGE_KEYS.token);
      state.user = null;
      state.token = null;
    },
    setCredentials: (
      state,
      action: PayloadAction<Pick<AuthState, "user" | "token">>
    ) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    setUser: (state, action: PayloadAction<Pick<AuthState, "user">>) => {
      state.user = action.payload.user;
    },
    temporaryToken: (
      state,
      action: PayloadAction<Pick<AuthState, "tempToken">>
    ) => {
      state.tempToken = action.payload.tempToken;
    },
    setPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload ? action.payload : null;
    },
    setDeviceToken: (state, action: PayloadAction<string>) => {
      console.log(action.payload, "deviceToken  fadfs");
      state.deviceToken = action.payload ? action.payload : null;
    },
  },
});
export const {
  resetAuth,
  setUser,
  setCredentials,
  temporaryToken,
  setPermissions,
  setDeviceToken,
} = authSlice.actions;
export const getCurrentUser = (state: RootState) => {
  console.log(state,'useruser')
  return state.auth.user;
};
export const getPermissions = (state: RootState) => state.auth.permissions;
export const getToken = (state: RootState) => state.auth.token;
export const getTempToken = (state: RootState) => state.auth.tempToken;
export const getDeviceToken = (state: RootState) => state.auth.deviceToken;
export default authSlice.reducer;
